module.exports = __webpack_public_path__ + "static/media/trial-ended.2df25400.svg";